import { render, staticRenderFns } from "./OceanProtocol.vue?vue&type=template&id=392811be&"
import script from "./OceanProtocol.vue?vue&type=script&lang=js&"
export * from "./OceanProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports